// extracted by mini-css-extract-plugin
module.exports = {"rectangular":"_3eJleHI15OxP8vt9VMcSZy"};